export const walletTokens = [
  'BTC',
  'ETH'
]

export const brokenTokenCodes = ['NIAH', 'SVC']



// WEBPACK FOOTER //
// ./src/js/const/tokens.const.js